import { useCallback, useState } from 'react';
import { Button } from '@ds';
import { useResourcesHandlers } from '@lp/features/RoutePlanner/hooks/useResourcesHandlers';
import { useResource } from '@lp/features/RoutePlanner/hooks/useResource';
import { useCaseDetailsWithReviews } from '@lp/features/RoutePlanner/hooks/useCaseDetailsWithReviews';
import { RSAssignmentCandidate, RSContractorAssignmentCandidate } from '@/api/apis/resources';
import { CaseResourceType } from '@/api/apis/case';
import { RoutePlannerSurgeonList } from '../SurgeonListTable/SurgeonList';

type SelectedSecondarySProps = {
  onClose: () => void;
  setParentLoading?: (loading: boolean) => void;
};

export const SelectSecondaryS = ({ onClose, setParentLoading }: SelectedSecondarySProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { caseId, organType } = useCaseDetailsWithReviews();
  const { handleResourceAssignment } = useResourcesHandlers({ id: caseId });
  const { handleSConfirmation } = useResource({ type: CaseResourceType.Surgeon, id: '' });
  const [selectedSecondaryS, setSelectedSecondaryS] = useState<
    RSContractorAssignmentCandidate | RSAssignmentCandidate | null
  >(null);

  const handleReserve = useCallback(
    async (secondaryS: RSContractorAssignmentCandidate | RSAssignmentCandidate) => {
      try {
        setIsLoading(true);
        setParentLoading?.(true);
        await handleResourceAssignment({
          data: { surgeonIds: [secondaryS.employeeId] },
          type: 'reserve',
        });
        onClose();
      } finally {
        setIsLoading(false);
        setParentLoading?.(false);
      }
    },
    [handleResourceAssignment, onClose, setParentLoading],
  );

  const handleSSelect = (employee: RSContractorAssignmentCandidate | RSAssignmentCandidate) => {
    setSelectedSecondaryS(employee);
  };

  const handleAddResource = () => {
    if (selectedSecondaryS) {
      handleSConfirmation(selectedSecondaryS, () => handleReserve(selectedSecondaryS));
    }
  };

  return (
    <div className="flex flex-col place-items-stretch gap-6">
      <div className="flex flex-col">
        <div className="px-1 py-2 flex flex-col">
          <RoutePlannerSurgeonList
            organType={organType}
            selectedResourceId={selectedSecondaryS?.employeeId}
            onAction={handleSSelect}
          />
        </div>
      </div>
      <div className="gap-4 flex flex-row justify-end">
        <Button onClick={onClose} variant="outline">
          Discard
        </Button>
        <Button isDisabled={isLoading} variant="solid" color="primary" onPress={handleAddResource}>
          Add Resource
        </Button>
      </div>
    </div>
  );
};
